import DownloadOutlined from "@mui/icons-material/DownloadOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useMemo } from "react";
import { usePdfDownloadHook } from "../../../hooks/usePdfDownloadHook";

const CellRendererDownloadCreditAuthPdf = (params) => {
  const data = params?.data;

  const filename = useMemo(() => {
    if (data?.firstName && data?.lastName) {
      return `${data.firstName}-${data.lastName}-credit-auth.pdf`;
    }
    return "credit-auth.pdf";
  }, [data]);

  const { downloadPDF, loading } = usePdfDownloadHook({
    formData: data,
    filename,
    type: "credit-authorization",
  });
  return (
    <Tooltip title="Download Credit Authorization PDF">
      <IconButton
        loading={loading}
        size="small"
        color="primary"
        onClick={downloadPDF}
        disabled={loading}
      >
        <DownloadOutlined className="thin-8" />
      </IconButton>
    </Tooltip>
  );
};

export default CellRendererDownloadCreditAuthPdf;
